/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import {ErrorWrapper} from "./error.wrapper";
import {ExceptionEntity} from "../../exception.model";
import {Injectable} from "@angular/core";

@Injectable()
export class BaseErrorWrapper implements ErrorWrapper {
    transform(error: any): ExceptionEntity | null {
        if (error instanceof Error) {
            const exception = new ExceptionEntity();
            exception.message = error.name;
            exception.truncatedStackTrace = error.message;
            exception.stackTrace = error.stack;
            return exception;
        } else {
            return null;
        }
    }

    canTransform(error: any): boolean {
        return (error instanceof Error);
    }
}
